const formatModalidad = (value) => {
  const modalidades = {
    en_linea: "En línea",
    presencial: "Presencial",
    hibrida: "Híbrida",
    distancia: "Distancia",
  };

  return modalidades[value] || value;
};

const Modalidad = ({ value }) => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null;
  }

  const modalidades = (Array.isArray(value) ? value : [value])
    .filter(Boolean)
    .map(formatModalidad);

  // Si solo hay una modalidad
  if (modalidades.length === 1) {
    return <p>{modalidades[0]}</p>;
  }

  // Si hay varias modalidades
  return (
    <ul>
      {modalidades.map((modalidad, index) => (
        <li key={index}>{modalidad}</li>
      ))}
    </ul>
  );
};

export default Modalidad;